import { render, staticRenderFns } from "./newsmenu-add.vue?vue&type=template&id=30853013&scoped=true&"
import script from "./newsmenu-add.vue?vue&type=script&lang=js&"
export * from "./newsmenu-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30853013",
  null
  
)

export default component.exports